import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/portfolio/portfolio.geo.query.gql"
import type {
  PortfolioGeoQuery,
  PortfolioGeoQueryVariables,
} from "@/v2-backoffice-client/portfolio/__types__/portfolio.geo.query"

type Options = QueryHookOptions<PortfolioGeoQuery, PortfolioGeoQueryVariables>

export function usePortfolioGeoQuery(options?: Options) {
  return useQuery<PortfolioGeoQuery, PortfolioGeoQueryVariables>(query, options)
}
